export default function FlightsOnewayController(
    $scope,
    $controller,
    flightsFactory,
    moment
) {
    'ngInject';

            $controller('OnewayBaseController', {
                $scope,
                flightsFactory,
                moment,
                cfg: {
                    resultsRoute: 'main.flights.results',
                },
            });
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flightsOnewayCtrl.js